<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_status === true">เปลี่ยนสถานะเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_delete === true">ลบใบสั่งซื้อสินค้าเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="mb-2">
            <h3>ใบสั่งซื้อสินค้า</h3>
            <div class="text-right">
                <v-btn color="#038cc1" class="white--text" @click="$router.push('/purchaseordernew')" width="20%" height="65">
                    สร้างใบสั่งซื้อสินค้า
                </v-btn>
            </div>
        </div>
        <v-card>
            <v-card-title>
                <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="data" :search="search">
                <template v-slot:item="dataDetail">
                    <tr>
                        <td>{{dataDetail.item.po_no}}</td>
                        <td>{{dataDetail.item.created_at}}</td>
                        <td>{{dataDetail.item.total_price}}</td>
                        <td>{{ dataDetail.item.user_name}}</td>
                        <td>
                            <div :class="dataDetail.item.status == 1 ? 'warning--text' :'success--text'">
                                {{ dataDetail.item.status == 1 ? 'กำลังดำเนินการ' : 'สำเร็จ' }}
                            </div>
                        </td>
                        <td>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                                </template>
                                <v-list>
                                    <v-list-item class="cursor_purcase_order_list" :to="'/purchaseorderdetail/'+dataDetail.item.id" target="_blank">
                                        <v-list-item-title>ดูรายละเอียด</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item class="cursor_purcase_order_list" v-if="dataDetail.item.status == 1" @click="purchaseOrderNewDetail(dataDetail.item.id)">
                                        <v-list-item-title>แก้ไข</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item class="cursor_purcase_order_list" v-if="dataDetail.item.status == 1" @click="confirmDeletePurchaseOrderNewList(dataDetail.item.id,dataDetail.item.po_no)">
                                        <v-list-item-title>ลบ</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">mdi-download</v-icon>
                                </template>
                                <v-list>
                                    <v-list-item class="cursor_purcase_order_list" v-for="(source,index) in dataDetail.item.source_list" :key="index" @click="purchaseOrderNewDetailPDF(dataDetail.item.id,source.source_id)">
                                        <v-list-item-title>{{ source.source_name }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>

                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <v-dialog v-model="open_confirm_delete" persistent max-width="600px">

            <div v-if="loading_page_confirm_delete === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_confirm_delete === false">
                <v-card-title>
                    คำเตือน
                </v-card-title>

                <v-card-text>
                    ต้องการลบใบสั่งซื้อสินค้า {{ delete_detail.po_no }} ใช่หรือไม่ ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" height="50" @click="deletePurchaseOrderNewList()">
                        บันทึก
                    </v-btn>
                    <v-btn color="error" height="50" @click="cancelDeletePurchaseOrderNewList()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import stockpurchaseorder from '@/api/stock/stocklist/stockpurchaseorder.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_page_confirm_delete: true,
            open_confirm_delete: false,
            alert_show_status: false,
            alert_show_delete: false,
            search: '',
            headers: [{
                    text: 'รหัส',
                    align: 'start',
                    value: 'po_no',
                },
                {
                    text: 'วัน-เวลา',
                    align: 'date',
                    value: 'created_at'
                },
                {
                    text: 'มูลค่ารวม',
                    value: 'total_price'
                },
                {
                    text: 'ผู้สร้าง',
                    value: 'user_name'
                },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
                {
                    text: 'PDF',
                    value: 'pdf'
                },
            ],
            data: [],
            delete_detail: {
                id: null,
                po_no: null
            },
        }
    },
    methods: {
        async purchaseOrderList() {
            this.loading_page = true
            this.data = []
            stockpurchaseorder.purchaseOrderList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.list
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

        },
        async purchaseOrderStatus(id, status) {
            this.loading_page = true
            const data = {
                status: status
            }
            stockpurchaseorder.purchaseOrderStatus(id, data).then((response) => {
                if (response.data.successful === true) {
                    this.purchaseOrderList()
                    this.$store.commit('clearPurchaseOrderNewDetailPage')
                    this.alert_show_status = true
                    setTimeout(() => this.alert_show_status = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async purchaseOrderNewDetail(id) {
            const idPage = {
                id: id,
            }
            this.$store.commit('purchaseOrderNewDetailPage', idPage)
            this.$router.push('/purchaseordernewdetail')
        },
        async confirmDeletePurchaseOrderNewList(id, po_no) {
            this.loading_page_confirm_delete = true
            this.open_confirm_delete = true
            this.delete_detail = {
                id: id,
                po_no: po_no
            }
            this.loading_page_confirm_delete = false
        },
        async cancelDeletePurchaseOrderNewList() {
            this.open_confirm_delete = false
            this.delete_detail = {
                id: null,
                po_no: null
            }
        },
        async deletePurchaseOrderNewList() {
            this.open_confirm_delete = false
            this.loading_page = true
            stockpurchaseorder.deletePurchaseOrderNewList(this.delete_detail.id).then((response) => {
                if (response.data.successful === true) {
                    this.purchaseOrderList()
                    this.$store.commit('clearPurchaseOrderNewDetailPage')
                    this.delete_detail = {
                        id: null,
                        po_no: null
                    }
                    this.alert_show_delete = true
                    setTimeout(() => this.alert_show_delete = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async purchaseOrderNewDetailPDF(id, source_id) {
            window.open(
                `${process.env.VUE_APP_BASE_URL}purchase_order/PO_PDF/?po_id=${id}&sources_id=${source_id}`,
                '_blank'
            );
        }
    },
    mounted() {
        this.purchaseOrderList()
    }
}
</script>

<style scoped>
.cursor_purcase_order_list {
    cursor: pointer;
}
</style>
